import * as React from 'react';

function SvgYoutubeColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.404 7.188C4.272 7.188 3 9.726 3 12.858v5.998c0 3.132 1.405 5.67 4.537 5.67h16.114c3.13 0 4.201-2.538 4.201-5.67v-5.998c0-3.132-.937-5.67-4.07-5.67H7.404z"
        fill="url(#YoutubeColour_svg__paint0_radial)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.935 12.469l6.77 3.534-6.77 3.531V12.47z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.935 12.523l5.888 3.938.882-.458-6.246-3.26-.524-.227v.007z"
        fill="#E8E0E0"
      />
      <defs>
        <radialGradient
          id="YoutubeColour_svg__paint0_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 10.0971 -20.7651 0 15.426 15.857)"
        >
          <stop stopColor="#B31217" />
          <stop offset={1} stopColor="#E52D27" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export default SvgYoutubeColour;
